import React, { useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { CookiesKeys, URLs } from '../../Constants/Consts'
import { fetchApi } from '../../Helpers/Functions'
import { RootState } from '../../store/store'
import Cookies from "js-cookie";
import { addBusinessUnites } from '../../store/BusinessUnites'

export default function storeBusinessUnites() {

    const [isloading, setIsloading] = React.useState(false)
    const dispatch = useDispatch()
    const SelectedUser = useSelector(
        (state: RootState) => state.SelectedUser.SelectedUser
    );
    const { downloadTriggered: { businessUnites: triggered } } = useSelector(
        (state: RootState) => state.Utilities
    );
    const calledOnceRef = useRef(false)
    const currentToken = Cookies.get(CookiesKeys.jwt)

    React.useEffect(() => {
        (async () => {
            try {
                if (navigator.onLine && SelectedUser.jwt && currentToken && (!calledOnceRef.current || triggered)) {
                    calledOnceRef.current = true
                    setIsloading(true)
                    const businessUnites = await fetchApi(
                        URLs.getBusinessUnits())
                        .then(res => res.json())
                    // update store
                    dispatch(addBusinessUnites(businessUnites))
                    setIsloading(false)
                }
            } catch (error) {
                console.error("error from download business unites", error);
            }
        })()
    }, [SelectedUser.jwt, triggered])
    return { isloading }
}
